/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import {ApiConfig} from "../../../api";
import {AdnHttpService} from '../../../../util/adn-http.service';
import {
  AdnHttpSender,
  createAdnHttpResourceSender
} from '../../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../../app/common/directives/error/api-error-handler.service';

@Injectable()
export class BurnRatesResource {
  private readonly uri = ApiConfig.obtain().getVersionedUri('burnrates');
  private readonly defaultParams = {
    startDate: moment().subtract(7, 'd'),
    endDate: moment()
  };
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  get(params, cb, errCb) {
    params = _.assign({}, this.defaultParams, params);
    if (params.startDate && params.startDate.toISOString) {
      params.startDate = params.startDate.toISOString();
    }
    if (params.endDate && params.endDate.toISOString) {
      params.endDate = params.endDate.toISOString();
    }
    const request = {
      method: 'GET',
      url: this.uri + '/' + params.id,
      params: _.omit(params, ['id', 'idKey']),
      hasErrorHandler: _.isFunction(errCb)
    };
    return this.send(request).then(function(data) {
      return (cb || _.noop)(data);
    }).catch(function(response) {
      return (errCb || _.noop)(response);
    });
  }
}
